import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AgentService {

  constructor(private http: HttpClient) {
  }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': environment.publicApiToken,
    });
  }

  getFormDataRequestHeaders() {
    return new HttpHeaders({
      Authorization: localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  get(params: any) {
    return this.http.get(environment.apiUrl + '/agents', {params: params, headers: this.getRequestHeaders()}).toPromise();
  }

  getById(id: string) {
    return this.http.get(environment.apiUrl + '/agents/' + id, {headers: this.getRequestHeaders()});
  }

  delete(id: string) {
    return this.http.delete(environment.apiUrl + '/agents/' + id, {headers: this.getRequestHeaders()});
  }

  approve(id: string) {
    return this.http.put(environment.apiUrl + '/agents/' + id + '/approve', {}, {headers: this.getRequestHeaders()});
  }

  reject(id: string) {
    return this.http.put(environment.apiUrl + '/agents/' + id + '/reject', {}, {headers: this.getRequestHeaders()});
  }

    upload(formData: FormData) {
        return this.http.post(environment.apiUrl + '/agents/upload', formData, {headers: this.getFormDataRequestHeaders()}).toPromise();
    }

}
